export default [
    {
        path: 'relatorio-financeiro-paciente',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-relatorio-financeiro-paciente' */
            '@/views/exame-laboratorial/relatorio-financeiro-paciente/Index'
        ),
        redirect: 'relatorio-financeiro-paciente/index',
        children: [
            {
                name: 'exame-laboratorial-relatorio-financeiro-paciente-index',
                path: 'index',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-relatorio-financeiro-paciente' */
                    '@/views/exame-laboratorial/relatorio-financeiro-paciente/List.vue'
                ),
            },
        ],
    }
]